<script setup lang="ts">
import { storeToRefs } from 'pinia'

import NudgeCard from '~/components/draft/influencerListing/NudgeCard.vue'

import { useSeoListUrlDataToEntity } from '~/composables/useSeoListUrlDataToEntity'
import { useGetTranslatedTagEntityName } from '~/composables/useTagHelpers'

import { useMiscResizeStore } from '~/stores/miscResize'
import { useUserStore } from '~/stores/user'

import type { InfluencerListingNudgeKind } from '~/types/influencerListingNudgeKind'
import type { SeoListsAsyncData } from '~/types/influencerListTagSeo'
import type { I18nTextKey } from '~/types/seoList'

type Props = {
  urlData: SeoListsAsyncData['urlData']
}
const props = defineProps<Props>()

const { entities } = useSeoListUrlDataToEntity(props.urlData)
const getTranslatedTagEntityName = useGetTranslatedTagEntityName()

const { SCREEN_WIDTH } = storeToRefs(useMiscResizeStore())
const { IS_BAND: USER_IS_BAND } = storeToRefs(useUserStore())

type TitleProp = Record<never, never> | Record<'influencer_kind', string>

const kind = computed<InfluencerListingNudgeKind>(() => {
  const addString = SCREEN_WIDTH.value < 768 ? '_small' : ('' as const)

  if (props.urlData[0].tagTypeName !== 'influencer_kind')
    return `seo_listing_simple${addString}` as const

  return `seo_listing_simple_influencer_kind_edge_case${addString}` as const
})
// We don't need to check priority here since we read from the url directly!
const i18nKey = computed<I18nTextKey>(
  () => props.urlData.map((data) => data.tagTypeName).join('_') as I18nTextKey,
)

const titleProps = computed<TitleProp>(() => {
  if (props.urlData[0].tagTypeName !== 'influencer_kind') return {}
  else
    return {
      influencer_kind: getTranslatedTagEntityName(
        entities.value[0],
        props.urlData[0].tagTypeName,
        2,
      ).toLowerCase(),
    }
})
</script>

<template>
  <NudgeCard
    class="tw-rounded-xs tw-border tw-border-solid tw-border-orange-500 tw-bg-orange-100"
    :class="{ small: !USER_IS_BAND }"
    :kind="kind"
    :title-props="titleProps"
    hide-picture
  />
</template>
